import { render } from "./BnkAmend.vue?vue&type=template&id=2f1b9b63"
import script from "./BnkAmend.vue?vue&type=script&lang=js"
export * from "./BnkAmend.vue?vue&type=script&lang=js"

import "./BnkAmend.vue?vue&type=style&index=0&id=2f1b9b63&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__